import { render, staticRenderFns } from "./CompanyBeneficialOwnerRegistry.vue?vue&type=template&id=f9922d42&scoped=true&"
import script from "./CompanyBeneficialOwnerRegistry.vue?vue&type=script&lang=js&"
export * from "./CompanyBeneficialOwnerRegistry.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBeneficialOwnerRegistry.vue?vue&type=style&index=0&id=f9922d42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9922d42",
  null
  
)

export default component.exports